/* eslint-disable */

export const prepearedVolumeSell = {
    GET_PREPEARED_VOLUME_SELL_REQUEST: 'GET_PREPEARED_VOLUME_SELL_REQUEST',
    GET_PREPEARED_VOLUME_SELL_SUCCESS: 'GET_PREPEARED_VOLUME_SELL_SUCCESS',
    GET_PREPEARED_VOLUME_SELL_FAILURE: 'GET_PREPEARED_VOLUME_SELL_FAILURE',
};
